// React-App Polyfill to allow app on IE11 -- These must be put at the top of index.js to work!!
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'es6-object-assign';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import { Provider } from 'react-redux';
import store from 'redux/store';
import { qdashTheme } from './assets/qdash-theme';
import { ThemeProvider } from '@material-ui/core';

ReactDOM.render(
    <ThemeProvider theme={qdashTheme}>
        <Provider store={store} >
            <Router>
                <App />
            </Router>
        </Provider>
    </ThemeProvider>,
    document.getElementById('root')
);
